export default __webpack_public_path__ + "static/media/requestSent.4ad8c6ac.svg";